import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=02e425ba&scoped=true&"
import script from "./MyTeam.vue?vue&type=script&lang=js&"
export * from "./MyTeam.vue?vue&type=script&lang=js&"
import style0 from "./MyTeam.vue?vue&type=style&index=0&id=02e425ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e425ba",
  null
  
)

export default component.exports